// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---node-modules-wkocjan-gatsby-theme-intro-src-pages-404-js": () => import("./../../../node_modules/@wkocjan/gatsby-theme-intro/src/pages/404.js" /* webpackChunkName: "component---node-modules-wkocjan-gatsby-theme-intro-src-pages-404-js" */),
  "component---node-modules-wkocjan-gatsby-theme-intro-src-templates-index-js": () => import("./../../../node_modules/@wkocjan/gatsby-theme-intro/src/templates/index.js" /* webpackChunkName: "component---node-modules-wkocjan-gatsby-theme-intro-src-templates-index-js" */)
}

